import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

const getLongRunningAnalysisState = (state: RootState) => state.longRunningOperations.analysis;
const getLongRunningUploadState = (state: RootState) => state.longRunningOperations.upload;

export const isLongRunningAnalysisOngoing = createSelector(getLongRunningAnalysisState, (analysis) => analysis != null);
export const shouldShowAnalysisDialog = isLongRunningAnalysisOngoing;

export const isLongRunningUploadOngoing = createSelector(getLongRunningUploadState, (upload) => upload != null);
export const shouldShowUploadDialog = isLongRunningUploadOngoing;

export const isLongRunningAnalysisFinished = createSelector(getLongRunningAnalysisState, (analysis) => {
  if (analysis == null) return true;

  return Object.values(analysis.componentDesigns).every(
    (design) => design.currentStage === 'finished' || design.currentStage === 'failed',
  );
});

export const canLongRunningAnalysisBeCanceled = createSelector(
  [getLongRunningAnalysisState, isLongRunningAnalysisFinished],
  (analysis, isFinished) => analysis && !analysis.canceled && !isFinished,
);
